import GR1 from '@rategravity/frontend/theme/webfonts/Graphik-Semibold.eot';
import GR2 from '@rategravity/frontend/theme/webfonts/Graphik-Semibold.eot?#iefix';
import GR5 from '@rategravity/frontend/theme/webfonts/Graphik-Semibold.ttf';
import GR4 from '@rategravity/frontend/theme/webfonts/Graphik-Semibold.woff';
import GR3 from '@rategravity/frontend/theme/webfonts/Graphik-Semibold.woff2';

export const GraphikSemibold = {
  src: `url(${GR1}), url(${GR2}), url(${GR3}), url(${GR4}), url(${GR5})`
};
